<template>
  <div class="rating w-100" :class="dynamicClass">
    <div v-for="i in new Array(content)" :key="i" class="material-icons md-16">star</div>
    <span v-for="i in new Array(5 - content)" :key="i" class="negate-gap material-icons md-16">star_border</span>
  </div>
</template>

<script>
export default {
  name: 'RatingField',
  props: {
    content: {
      type: Number,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClass() {
      return this.inDetailView || this.isCardView
        ? this.content
          ? 'text-start negate-gap'
          : 'text-start'
        : 'text-center'
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
  },
}
</script>

<style lang="scss" scoped>
.rating {
  color: $color-text-regular;
}
span.negate-gap:first-of-type {
  margin-left: -4px;
}
div.negate-gap {
  margin-inline-start: -3px;
}
</style>
